import { constants } from "@cinch-nx/data-search";
const { defaultFilters , defaultNonFilterParams  } = constants;
const defaultParams = {
    ...defaultFilters,
    ...defaultNonFilterParams
};
export function convertSearchFiltersToQueryParams(filters, allCinchStores) {
    const urlParams = new URLSearchParams();
    const filterEntries = Object.entries(filters)// maintain consistent order of keys
    .sort((a, b)=>a[0].localeCompare(b[0]));
    for (const [key, value] of filterEntries){
        if (key === "store" && Array.isArray(value) && value.length === 1 && (allCinchStores === null || allCinchStores === void 0 ? void 0 : allCinchStores.length) === 1 && allCinchStores[0] === value[0]) {
            urlParams.set("store", "all-stores");
        } else if (Array.isArray(value) && value.length > 0) {
            urlParams.set(key, value.join(","));
        } else if (value !== defaultParams[key]) {
            urlParams.set(key, `${value}`);
        }
    }
    return urlParams;
}
